var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { BaseComponent, BaseComponentPlus } from "react-vextensions";
import { Row, CheckBox, Text } from "react-vcomponents";
import { store } from "Store";
import { RunInAction_Set, HSLA, Observer } from "vwebapp-framework";
import { voiceCommands } from "@Shared/VoiceCommands";
import { voiceEngine } from "@Shared/VoiceEngine";
let VoicePanel = class VoicePanel extends BaseComponent {
    render() {
        const uiState = store.main.voice;
        return (React.createElement(Row, { center: true, style: { position: "fixed", left: 60, right: 0, top: 0, height: 45, padding: 5, background: "rgba(0,0,0,.7)", borderRadius: "0 0 0 5px" } },
            React.createElement(CheckBox, { text: "Enabled", checkboxProps: { className: "notFocusTarget" }, style: { flexShrink: 0 }, value: voiceEngine.enabled, onChange: val => {
                    RunInAction_Set(this, () => {
                        if (val)
                            voiceEngine.Start();
                        else
                            voiceEngine.Stop();
                    });
                } }),
            React.createElement(Text, { ml: 10, style: { flexShrink: 0 } }, "Commands (16XX):"),
            React.createElement(Row, { style: { height: 45, alignItems: "flex-start", flexWrap: "wrap", padding: 1 } }, voiceCommands.map((command, index) => {
                return React.createElement(VoiceCommandLabel, { key: index, command: command });
            }))));
    }
};
VoicePanel = __decorate([
    Observer
], VoicePanel);
export { VoicePanel };
class VoiceCommandLabel extends BaseComponentPlus({}, {}) {
    render() {
        const { command } = this.props;
        const autoVoiceKey = command.voiceKeys[0];
        const match = command.action.toString().match(/\{((.|\s)*)\}/);
        const actionSet = match[1].trim().length > 0;
        return (React.createElement(Row, { ml: 5, style: { flexShrink: 0, fontSize: 12 }, title: `VoiceKeys:\n${command.voiceKeys.slice(1).join("\n")}` },
            React.createElement(Text, null,
                command.name,
                ":"),
            React.createElement(Text, { ml: 3, style: { color: actionSet ? HSLA(120, 1, .5) : "red" } }, autoVoiceKey.slice(2))));
    }
}
